
import { defineComponent, onBeforeMount, reactive } from 'vue'

import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

import { DataState } from '@/core/classes/DataState.class'
import { UserT } from '@/core/types/users.types'
import { users } from '@/core/realisations/users.realisation'

export default defineComponent({
    components: {
        TheInput,
        TheSelect,
        TheButton,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['resetted', 'search'],
    setup(props, { emit }) {
        const state = reactive({
            name: null as string | null,
            user_id: null as number | null,
            from_created_at: null as string | null,
            to_created_at: null as string | null,
        })

        const data_state = reactive({
            users: new DataState<UserT>({}),
        })

        const reset = () => {
            if (props.loading) return

            state.name = null
            state.user_id = null
            state.from_created_at = null
            state.to_created_at = null

            emit('resetted')
        }

        const search = () => {
            if (props.loading) return

            emit('search', {
                name: state.name,
                user_id: state.user_id,
                from_created_at: state.from_created_at,
                to_created_at: state.to_created_at,
            })
        }

        //

        const loadUsers = async (page: number) => {
            data_state.users.pagination.current_page = page

            try {
                data_state.users.is_loading = true

                const data = await users.getLogists(page)
                data_state.users.list = data.data

                data_state.users.pagination.total_pages = data.meta.last_page

                data_state.users.is_failed = false
                data_state.users.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.users.failure.catchError(error)

                if (!data_state.users.failure.error_state.is_cancel) {
                    data_state.users.is_failed = true
                }
            } finally {
                if (!data_state.users.failure.error_state.is_cancel) {
                    data_state.users.is_loading = false
                }
            }
        }

        const loadMoreUsers = async (page: number) => {
            if (page > data_state.users.pagination.total_pages) return
            data_state.users.pagination.current_page = page

            try {
                data_state.users.is_loading = true

                const response = await users.getLogists(page)
                data_state.users.list = data_state.users.list.concat(response.data)

                data_state.users.pagination.total_pages = response.meta.last_page

                data_state.users.is_failed = false
                data_state.users.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.users.failure.catchError(error)

                if (!data_state.users.failure.error_state.is_cancel) {
                    data_state.users.is_failed = true
                }
            } finally {
                if (!data_state.users.failure.error_state.is_cancel) {
                    data_state.users.is_loading = false
                }
            }
        }

        //

        onBeforeMount(() => {
            loadUsers(1)
        })

        return {
            state,
            data_state,
            reset,
            search,
            loadUsers,
            loadMoreUsers,
        }
    },
})
